import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, Youtube, Linkedin, Mail, Phone, MapPin } from "lucide-react";
import { scrollToId } from "../lib/scroll";

const SOCIALS = [
  { name: "Facebook", icon: Facebook, href: "https://www.facebook.com/oceanmindai/" },
  { name: "Instagram", icon: Instagram, href: "https://www.instagram.com/oceanmindai_official/" },
  { name: "X", icon: Twitter, href: "https://x.com/oceanmindai" },,
  { name: "YouTube", icon: Youtube, href: "https://www.youtube.com/@oceanmindai" },
  { name: "LinkedIn", icon: Linkedin, href: "https://www.linkedin.com/company/ocean-mind-ai/" },
];

export const Footer = () => {
  return (
    <footer className="relative border-t border-[#00F2FE]/10 pt-16 pb-10 px-6" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 md:gap-8">
          <div>
            <div className="flex items-center gap-2.5 mb-5">
              <img
                src="/images/logo-mark.png"
                alt="Ocean Mind AI logo"
                className="w-9 h-9 rounded-full ring-1 ring-[#00F2FE]/40"
              />
              <span className="font-['Outfit'] font-semibold text-[#E8F1F5]">
                Ocean<span className="gradient-text">Mind</span> AI
              </span>
            </div>
            <p className="text-sm text-[#8AA1B1] leading-relaxed max-w-xs">
              Intelligence beneath the surface. AI automation engineered in London.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {SOCIALS.map((s) => (
                <a
                  key={s.name}
                  data-testid={`social-${s.name.toLowerCase()}`}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  className="w-10 h-10 rounded-full border border-[#00F2FE]/25 flex items-center justify-center text-[#8AA1B1] hover:text-[#00F2FE] hover:border-[#00F2FE]/60 hover:bg-[#00F2FE]/10 hover:shadow-[0_0_20px_-6px_rgba(0,242,254,0.5)] transition-[color,border-color,background-color,box-shadow] duration-300"
                >
                  <s.icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-['Outfit'] font-medium text-sm tracking-[0.2em] uppercase text-[#E8F1F5] mb-6">Explore</h4>
            <div className="flex flex-col gap-3.5 text-sm text-[#8AA1B1]">
              <button data-testid="footer-link-services" onClick={() => scrollToId("#services")} className="text-left hover:text-[#00F2FE] transition-colors w-fit">Services</button>
              <button data-testid="footer-link-process" onClick={() => scrollToId("#process")} className="text-left hover:text-[#00F2FE] transition-colors w-fit">Process</button>
              <button data-testid="footer-link-contact" onClick={() => scrollToId("#contact")} className="text-left hover:text-[#00F2FE] transition-colors w-fit">Contact</button>
              <Link data-testid="footer-link-privacy" to="/privacy" className="hover:text-[#00F2FE] transition-colors w-fit">Privacy Policy</Link>
              <Link data-testid="footer-link-terms" to="/terms" className="hover:text-[#00F2FE] transition-colors w-fit">Terms & Conditions</Link>
            </div>
          </div>

          <div>
            <h4 className="font-['Outfit'] font-medium text-sm tracking-[0.2em] uppercase text-[#E8F1F5] mb-6">Get in touch</h4>
            <div className="flex flex-col gap-4 text-sm text-[#8AA1B1]">
              <a data-testid="footer-email" href="mailto:team@oceanmindai.co.uk" className="flex items-center gap-3 hover:text-[#00F2FE] transition-colors w-fit">
                <Mail className="w-4 h-4 text-[#00F2FE] shrink-0" /> team@oceanmindai.co.uk
              </a>
              <a data-testid="footer-phone" href="tel:+442037572456" className="flex items-center gap-3 hover:text-[#00F2FE] transition-colors w-fit">
                <Phone className="w-4 h-4 text-[#00F2FE] shrink-0" /> 020 3757 2456
              </a>
              <p data-testid="footer-address" className="flex items-start gap-3 leading-relaxed">
                <MapPin className="w-4 h-4 text-[#10E59A] shrink-0 mt-0.5" />
                <span>4th Floor, 45 Silver Stream House,<br />Fitzroy Street, Fitzrovia,<br />London, W1T 6EB</span>
              </p>
              <img
                src="/images/brand/company-seal-transparent.png"
                alt="Ocean Mind AI Limited company seal"
                data-testid="footer-seal"
                className="w-24 h-24 mt-2 opacity-80 hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#00F2FE]/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#8AA1B1]/60">© 2026 Ocean Mind AI. All rights reserved.</p>
          <a data-testid="footer-website" href="https://www.oceanmindai.co.uk" target="_blank" rel="noopener noreferrer" className="text-xs text-[#8AA1B1]/60 hover:text-[#00F2FE] transition-colors">
            www.oceanmindai.co.uk
          </a>
        </div>
      </div>
    </footer>
  );
};
